(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["efs-details-container"] && !Shopify.designMode) return;
  try {
    
  class DetailsContainer extends HTMLElement {
    constructor() {
      super();
      this.singleOpenOnly = this.dataset.singleOpen === 'true';
      this.columns = this.querySelectorAll('.efs-details-container__column');
      this.mediaQuery = window.matchMedia('(min-width: 750px)');

      this.init();
    }

    init() {
      this.addEventListener('click', this.handleClick.bind(this));
      this.mediaQuery.addEventListener('change', this.handleResize.bind(this));
      this.addEventListener('keydown', this.handleKeydown.bind(this));
    }

    toggleColumn(column, forceOpen = null) {
      const isOpen = column.classList.contains('is-open');
      const shouldOpen = forceOpen !== null ? forceOpen : !isOpen;
      const header = column.querySelector('.efs-details-container__header');
      const content = column.querySelector('.efs-details-container__content');

      if (shouldOpen) {
        if (this.singleOpenOnly) {
          this.columns.forEach((col) => {
            if (col !== column && col.classList.contains('is-open')) {
              this.toggleColumn(col, false);
            }
          });
        }
        column.classList.add('is-open');
        header.setAttribute('aria-expanded', 'true');
        content.removeAttribute('hidden');
      } else {
        column.classList.remove('is-open');
        header.setAttribute('aria-expanded', 'false');
        setTimeout(() => {
          if (!column.classList.contains('is-open')) {
            content.setAttribute('hidden', '');
          }
        }, 300);
      }
    }

    handleClick(event) {
      if (this.mediaQuery.matches) return;

      const header = event.target.closest('.efs-details-container__header');
      if (!header) return;

      const column = header.closest('.efs-details-container__column');
      if (!column) return;

      this.toggleColumn(column);
    }

    handleResize() {
      if (this.mediaQuery.matches) {
        this.columns.forEach((column) => {
          const content = column.querySelector('.efs-details-container__content');
          content.removeAttribute('hidden');
        });
      } else {
        this.columns.forEach((column) => {
          const content = column.querySelector('.efs-details-container__content');
          const isOpen = column.classList.contains('is-open');
          if (!isOpen) {
            content.setAttribute('hidden', '');
          }
        });
      }
    }

    handleKeydown(event) {
      if (this.mediaQuery.matches) return;

      const header = event.target.closest('.efs-details-container__header');
      if (!header) return;

      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        const column = header.closest('.efs-details-container__column');
        if (column) {
          this.toggleColumn(column);
        }
      }
    }
  }

  customElements.define('details-container', DetailsContainer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["efs-footer-columns"] && !Shopify.designMode) return;
  try {
    
  class FooterColumns extends HTMLElement {
    constructor() {
      super();
      this.singleOpenOnly = this.dataset.singleOpen === 'true';
      this.columns = this.querySelectorAll('.efs-footer-columns__column');
      this.mediaQuery = window.matchMedia('(min-width: 750px)');

      this.init();
    }

    init() {
      this.addEventListener('click', this.handleClick.bind(this));
      this.mediaQuery.addEventListener('change', this.handleResize.bind(this));
      this.addEventListener('keydown', this.handleKeydown.bind(this));
    }

    toggleColumn(column, forceOpen = null) {
      const isOpen = column.classList.contains('is-open');
      const shouldOpen = forceOpen !== null ? forceOpen : !isOpen;
      const header = column.querySelector('.efs-footer-columns__header');
      const content = column.querySelector('.efs-footer-columns__content');

      if (shouldOpen) {
        if (this.singleOpenOnly) {
          this.columns.forEach((col) => {
            if (col !== column && col.classList.contains('is-open')) {
              this.toggleColumn(col, false);
            }
          });
        }
        column.classList.add('is-open');
        header.setAttribute('aria-expanded', 'true');
        content.removeAttribute('hidden');

        if (this.singleOpenOnly) {
          this.scrollToColumn(column);
        }
      } else {
        column.classList.remove('is-open');
        header.setAttribute('aria-expanded', 'false');
        setTimeout(() => {
          if (!column.classList.contains('is-open')) {
            content.setAttribute('hidden', '');
          }
        }, 300);
      }
    }

    scrollToColumn(column) {
      setTimeout(() => {
        const stickyHeader = document.querySelector(
          '.header-wrapper.header-wrapper--sticky, .shopify-section-header-sticky'
        );
        const offset = stickyHeader ? stickyHeader.offsetHeight + 16 : 16;
        const rect = column.getBoundingClientRect();

        if (rect.top < offset) {
          const scrollPosition = rect.top + window.scrollY - offset;
          window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
        }
      }, 350);
    }

    handleClick(event) {
      if (this.mediaQuery.matches) return;

      const header = event.target.closest('.efs-footer-columns__header');
      if (!header) return;

      const column = header.closest('.efs-footer-columns__column');
      if (!column) return;

      this.toggleColumn(column);
    }

    handleResize() {
      if (this.mediaQuery.matches) {
        this.columns.forEach((column) => {
          const content = column.querySelector('.efs-footer-columns__content');
          content.removeAttribute('hidden');
        });
      } else {
        this.columns.forEach((column) => {
          const content = column.querySelector('.efs-footer-columns__content');
          const isOpen = column.classList.contains('is-open');
          if (!isOpen) {
            content.setAttribute('hidden', '');
          }
        });
      }
    }

    handleKeydown(event) {
      if (this.mediaQuery.matches) return;

      const header = event.target.closest('.efs-footer-columns__header');
      if (!header) return;

      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        const column = header.closest('.efs-footer-columns__column');
        if (column) {
          this.toggleColumn(column);
        }
      }
    }
  }

  customElements.define('footer-columns', FooterColumns);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
